import { useSelector } from 'react-redux';
import {
    quotaCleanerByLink,
    quotaCleanerFastEnable,
    quotaCleanerFastEnableMob,
    quotaCleanerFastGroupsByPriority,
    quotaCleanerForPaid,
} from 'reactApp/appHelpers/featuresHelpers/features/quotaCleaner';
import { EnvironmentSelectors } from 'reactApp/modules/environment/environment';
import {
    getFeatureQuotaCleanerCloud,
    getFeatureQuotaCleanerGroups,
    getFeatureQuotaCleanerLetters,
    getFeatureQuotaCleanerMob,
    getFeatureQuotaCleanerWeb,
} from 'reactApp/modules/features/features.selectors';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { resolveQuotaCleanerType } from 'reactApp/modules/userQuotaCleaner/helpers/resolveQuotaCleanerType';
import { quotaCleanerDebugLogger } from 'reactApp/modules/userQuotaCleaner/userQuotaCleaner.constants';
import {
    FastCleanSelectors,
    getGroupsIsLoaded,
    getGroupsIsLoadingError,
    isAllGroupsEmpty,
} from 'reactApp/modules/userQuotaCleaner/userQuotaCleaner.selectors';
import type { QuotaCleanerType } from 'reactApp/types/QuotaCleaner';

export const useQuotaCleanerType = (
    { isFromAction = false, isFromMail = false }: { isFromAction?: boolean; isFromMail?: boolean } = {
        isFromAction: false,
        isFromMail: false,
    }
): { isLoaded: boolean; type: QuotaCleanerType | null } => {
    const { isLoaded: isCanFastCleanLoaded } = useSelector(FastCleanSelectors.getState);
    const canFastClean = useSelector(FastCleanSelectors.getCanFastClean);
    const isAllCleanerGroupsEmpty = useSelector(isAllGroupsEmpty);
    const isGroupsLoaded = useSelector(getGroupsIsLoaded);

    const features = {
        quotaCleanerWeb: useSelector(getFeatureQuotaCleanerWeb),
        quotaCleanerMob: useSelector(getFeatureQuotaCleanerMob),
        quotaCleanerCloud: useSelector(getFeatureQuotaCleanerCloud),
        quotaCleanerLetters: useSelector(getFeatureQuotaCleanerLetters),
        quotaCleanerGroups: useSelector(getFeatureQuotaCleanerGroups),
        quotaCleanerForPaid,
        quotaCleanerFastEnable,
        quotaCleanerFastEnableMob,
        quotaCleanerFastGroupsByPriority,
        quotaCleanerByLink,
    };

    const params = {
        isMobile: useSelector(EnvironmentSelectors.isMobile),
        isAnonymous: useSelector(UserSelectors.isAnonymous),
        isPaid: useSelector(UserSelectors.isPaidUser),
        isCorp: useSelector(UserSelectors.isCorpUser),
        isBiz: useSelector(UserSelectors.isBizUser),
        isQuotaGroupsLoadingError: useSelector(getGroupsIsLoadingError),
        isAllLoadedEmpty: isGroupsLoaded ? isAllCleanerGroupsEmpty : false,
        canFastClean: isCanFastCleanLoaded ? canFastClean : true,
        isFromAction,
        isFromMail,
    };

    const type = resolveQuotaCleanerType(features, params);
    const isLoaded = isGroupsLoaded && isCanFastCleanLoaded;

    quotaCleanerDebugLogger.info('show check', { isLoaded, features, params, type });

    return { isLoaded, type };
};
